import { useTranslation } from 'react-i18next'
import { KibButtonNew } from '@chewy/kib-controls-react'
import { KibModal } from '@chewy/kib-overlays-react'

import '@chewy/kib-controls-styles/dist/styles/kib-button-new.css'
import '@chewy/kib-overlays-styles/dist/styles/kib-modal.css'
import styles from './ModalControls.module.scss'

export type RecordNavigationVariant = 'non-soap' | 'different-soap'

export interface RecordNavigationModalProps {
  currentPatientName?: string
  onCancel: () => void
  onContinueRecording: () => void
  onSwitchRecording?: () => void
  open: boolean
  recordingPatientName: string
  variant: RecordNavigationVariant
}

const RecordNavigationModal = ({
  open,
  onCancel,
  onContinueRecording,
  onSwitchRecording,
  recordingPatientName,
  currentPatientName,
  variant,
}: RecordNavigationModalProps) => {
  const { t } = useTranslation(['Dialogs'])

  const message = t('AUDIO_RECORDER.RECORD_NAVIGATION_MODAL.MESSAGE', {
    patientName: recordingPatientName,
  })

  const controls = () => (
    <div className={styles.controls}>
      {variant === 'different-soap' && onSwitchRecording && (
        <KibButtonNew
          emphasis="tertiary"
          theme="action"
          onClick={onSwitchRecording}
        >
          {t('AUDIO_RECORDER.RECORD_NAVIGATION_MODAL.SWITCH_BUTTON', {
            patientName: currentPatientName ?? '',
          })}
        </KibButtonNew>
      )}
      {variant === 'non-soap' && (
        <KibButtonNew emphasis="tertiary" theme="action" onClick={onCancel}>
          {t('AUDIO_RECORDER.RECORD_NAVIGATION_MODAL.CANCEL_BUTTON')}
        </KibButtonNew>
      )}
      <KibButtonNew theme="action" onClick={onContinueRecording}>
        {t('AUDIO_RECORDER.RECORD_NAVIGATION_MODAL.CONTINUE_BUTTON', {
          patientName: recordingPatientName,
        })}
      </KibButtonNew>
    </div>
  )

  return (
    <KibModal
      controls={controls}
      open={open}
      title={t('AUDIO_RECORDER.RECORD_NAVIGATION_MODAL.TITLE')}
      onClose={onCancel}
    >
      <p>{message}</p>
    </KibModal>
  )
}

export default RecordNavigationModal
